import React from "react";
import { useAuth } from "../context/AuthContext";
import { InactiveNotice } from "../pages/member/shared";

// Route-level gate (2026-08-23) - a member whose activation_status is not yet "active"
// must never render an earning/profile feature page, even by typing the URL directly.
// Wraps the route's element instead of relying on each page hiding its own content.
export function RestrictedForPendingMember({ children }) {
  const { member } = useAuth();
  const isActive = member?.member?.activation_status === "active";
  if (!isActive) {
    return (
      <div data-testid="restricted-pending-notice">
        <InactiveNotice label="This feature unlocks once your membership is activated." />
      </div>
    );
  }
  return children;
}
